"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertNever = void 0;
var assert_never_1 = require("./assert-never");
Object.defineProperty(exports, "assertNever", { enumerable: true, get: function () { return assert_never_1.assertNever; } });
